import { gql } from "@apollo/client";

const GET_ALL_SLUGS = gql`
  query ($pageSize: Int, $locale: I18NLocaleCode!) {
    blogPosts(pagination: { pageSize: $pageSize }, locale: $locale) {
      data {
        attributes {
          slug
        }
      }
    }
  }
`;

const GET_ALL_POSTS = gql`
query (
  $page: Int!
  $pageSize: Int!
  $search: String
  $tags: [String]
  $locale: I18NLocaleCode!
) {
  blogPosts(
    pagination: { page: $page, pageSize: $pageSize }
    filters: { 
    tags: { name: { in: $tags } } 
    title: { containsi: $search }
    }
    locale: $locale
    sort: "publishedAt:desc"
  ) {
    data {
      id
      attributes {
        title
        description
        slug
        author
        tags {
          data {
            id
            attributes {
              name
            }
          }
        }
        createdAt
        publishedAt
        preview_image {
          data {
            attributes {
              url
              name
            }
          }
        }
      }
    }
    meta {
      pagination {
        page
        pageSize
        total
        pageCount
      }
    }
  }
}
`;

const GET_INDIVIDUAL_POST = gql`
  query ($slugUrl: String!, $locale: I18NLocaleCode!) {
    blogPosts(filters: { slug: { eq: $slugUrl } }, locale: $locale) {
      data {
        id
        attributes {
          title
          description
          slug
          author
          content
          seo {
            metaTitle
            metaImage {
              data {
                attributes {
                  url
                }
              }
            }
            metaDescription
          }
          tags {
            data {
              id
              attributes {
                name
              }
            }
          }
          createdAt
          publishedAt
          preview_image {
            data {
              attributes {
                url
                name
              }
            }
          }
        }
      }
    }
  }
`;

const GET_ALL_TAGS = gql`
  query ($locale: I18NLocaleCode!) {
    tags(locale: $locale) {
      data {
        id
        attributes {
          name
        }
      }
    }
  }
`;

const GET_LAST_ARTICLES_BY_TAGS = gql`
query (
  $tags: [String]
  $locale: I18NLocaleCode!
) {
  blogPosts(
    pagination: { limit: 3 }
    filters: { tags: { name: { in: $tags } } }
    locale: $locale
    sort: "publishedAt:desc"
  ) {
    data {
      id
      attributes {
        title
        description
        slug
        author
        tags {
          data {
            id
            attributes {
              name
            }
          }
        }
        createdAt
        publishedAt
        preview_image {
          data {
            attributes {
              url
              name
            }
          }
        }
      }
    }
    meta {
      pagination {
        page
        pageSize
        total
        pageCount
      }
    }
  }
}
`;

export {
  GET_ALL_POSTS,
  GET_INDIVIDUAL_POST,
  GET_ALL_SLUGS,
  GET_ALL_TAGS,
  GET_LAST_ARTICLES_BY_TAGS,
};
